module.exports = __webpack_public_path__ + "assets/e24cb9e6ceb0eaf7435cf3672dd9a732.mp3";